import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";

type Props = {
  onActionEditar: (idItemchecklist: number | null, openState: boolean) => void;
  onActionDeletar: (idItemchecklist: number | null, openState: boolean) => void;
};

export const GenerateItemsChecklistColumnDefinition = ({ onActionEditar, onActionDeletar }: Props): GridColDef[] => {
  return [
    {
      field: "Codigo",
      headerName: "Codigo",
      minWidth: 100,
      sortable: false,
      filterable: false,
      headerClassName: "projeto-header",
    },
    {
      field: "Descricao",
      headerName: "Item",
      flex: 1,
      minWidth: 150,
      sortable: false,
      filterable: false,
      headerClassName: "projeto-header",
    },

    {
      field: "IdItemChecklist",
      headerName: "Ações",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.value, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.value, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
